import React, { Fragment } from "react";

import { Switcher as SharedSwitcher } from "@sportal/cdk/switcher/Switcher";

import "./Switcher.scss";

export const Switcher = ({ label, id, ...props }) => {
  const labelId = `${id}-label`;

  return (
    <Fragment>
      <div id={labelId}>{label}</div>
      <SharedSwitcher {...props} id={id} aria-labelledby={labelId} />
    </Fragment>
  );
};
